
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { WindowType } from '../../util';

declare var window: WindowType;

@Component({
  name: 'PrintModal',
})
export default class PrintModal extends Vue {
  reportType: 'detail' | 'overview' = 'detail';
  moreparams: any = {};

  //api
  public open(moreparams: any): void {
    this.moreparams = moreparams;
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  private printReport() {
    let url = window.application.baseUrl;
    if (this.reportType == 'detail') {
      url += 'printpdf';
    } else if (this.reportType == 'overview') {
      url += 'printpdf/pdfoverview';
    } else {
      throw new Error(`Unknown reportType: ${this.reportType}`);
    }
    url += '?' + Object.keys(this.moreparams).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(this.moreparams[k]));

    window.open(url, '_blank');
  }
}
